/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `AF` - Afghánistán * `AX` - Alandy * `AL` - Albánie * `DZ` - Alžírsko * `AS` - Americká Samoa * `VI` - Americké Panenské ostrovy * `AD` - Andorra * `AO` - Angola * `AI` - Anguilla * `AQ` - Antarktida * `AG` - Antigua a Barbuda * `AR` - Argentina * `AM` - Arménie * `AW` - Aruba * `AU` - Austrálie * `AZ` - Ázerbájdžán * `BS` - Bahamy * `BH` - Bahrajn * `BD` - Bangladéš * `BB` - Barbados * `BE` - Belgie * `BZ` - Belize * `BY` - Bělorusko * `BJ` - Benin * `BM` - Bermudy * `BT` - Bhútán * `BO` - Bolívie * `BQ` - Bonaire, Svatý Eustach a Saba * `BA` - Bosna a Hercegovina * `BW` - Botswana * `BV` - Bouvetův ostrov * `BR` - Brazílie * `VG` - Britské Panenské ostrovy * `IO` - Britské indickooceánské území * `BN` - Brunej * `BG` - Bulharsko * `BF` - Burkina Faso * `BI` - Burundi * `TD` - Čad * `ME` - Černá Hora * `CZ` - Česko * `CL` - Chile * `HR` - Chorvatsko * `CN` - Čína * `CK` - Cookovy ostrovy * `CW` - Curaçao * `DK` - Dánsko * `DM` - Dominika * `DO` - Dominikánská republika * `DJ` - Džibutsko * `EG` - Egypt * `EC` - Ekvádor * `ER` - Eritrea * `EE` - Estonsko * `SZ` - Eswatini * `ET` - Etiopie * `FO` - Faerské ostrovy * `FK` - Falklandy (Malvíny) * `FJ` - Fidži * `PH` - Filipíny * `FI` - Finsko * `FR` - Francie * `GF` - Francouzská Guyana * `PF` - Francouzská Polynésie * `TF` - Francouzská jižní a antarktická území * `GA` - Gabon * `GM` - Gambie * `GH` - Ghana * `GI` - Gibraltar * `GD` - Grenada * `GL` - Grónsko * `GE` - Gruzie * `GP` - Guadeloupe * `GU` - Guam * `GT` - Guatemala * `GG` - Guernsey * `GN` - Guinea * `GW` - Guinea-Bissau * `GY` - Guyana * `HT` - Haiti * `HM` - Heardův ostrov a McDonaldovy ostrovy * `HN` - Honduras * `HK` - Hongkong * `IN` - Indie * `ID` - Indonésie * `IQ` - Irák * `IR` - Írán * `IE` - Irsko * `IS` - Island * `IT` - Itálie * `IL` - Izrael * `JM` - Jamajka * `JP` - Japonsko * `YE` - Jemen * `JE` - Jersey * `ZA` - Jižní Afrika * `GS` - Jižní Georgie a Jižní Sandwichovy ostrovy * `KR` - Jižní Korea * `SS` - Jižní Súdán * `JO` - Jordánsko * `KY` - Kajmanské ostrovy * `KH` - Kambodža * `CM` - Kamerun * `CA` - Kanada * `CV` - Kapverdy * `QA` - Katar * `KZ` - Kazachstán * `KE` - Keňa * `KI` - Kiribati * `CC` - Kokosové (Keelingovy) ostrovy * `CO` - Kolumbie * `KM` - Komory * `CG` - Kongo * `CD` - Kongo, demokratická republika * `CR` - Kostarika * `CU` - Kuba * `KW` - Kuvajt * `CY` - Kypr * `KG` - Kyrgyzstán * `LA` - Laos * `LS` - Lesotho * `LB` - Libanon * `LR` - Libérie * `LY` - Libye * `LI` - Lichtenštejnsko * `LT` - Litva * `LV` - Lotyšsko * `LU` - Lucembursko * `MO` - Macao * `MG` - Madagaskar * `HU` - Maďarsko * `MY` - Malajsie * `MW` - Malawi * `MV` - Maledivy * `ML` - Mali * `MT` - Malta * `MA` - Maroko * `MH` - Marshallovy ostrovy * `MQ` - Martinik * `MU` - Mauricius * `MR` - Mauritánie * `YT` - Mayotte * `UM` - Menší odlehlé ostrovy USA * `MX` - Mexiko * `FM` - Mikronésie * `MD` - Moldavsko * `MC` - Monako * `MN` - Mongolsko * `MS` - Montserrat * `MZ` - Mosambik * `MM` - Myanma * `NA` - Namibie * `NR` - Nauru * `DE` - Německo * `NP` - Nepál * `NE` - Niger * `NG` - Nigérie * `NI` - Nikaragua * `NU` - Niue * `NL` - Nizozemsko * `NO` - Norsko * `NC` - Nová Kaledonie * `NZ` - Nový Zéland * `OM` - Omán * `IM` - Ostrov Man * `NF` - Ostrov Norfolk * `MP` - Ostrovy Severní Mariany * `TC` - Ostrovy Turks a Caicos * `PK` - Pákistán * `PW` - Palau * `PS` - Palestinské území (okupované) * `PA` - Panama * `PG` - Papua Nová Guinea * `PY` - Paraguay * `PE` - Peru * `PN` - Pitcairn * `CI` - Pobřeží Slonoviny * `PL` - Polsko * `PR` - Portoriko * `PT` - Portugalsko * `AT` - Rakousko * `GR` - Řecko * `RE` - Réunion * `GQ` - Rovníková Guinea * `RO` - Rumunsko * `RU` - Rusko * `RW` - Rwanda * `PM` - Saint Pierre a Miquelon * `SB` - Šalomounovy ostrovy * `SV` - Salvador * `WS` - Samoa * `SM` - San Marino * `SA` - Saúdská Arábie * `SN` - Senegal * `KP` - Severní Korea * `MK` - Severní Makedonie * `SC` - Seychely * `SL` - Sierra Leone * `SG` - Singapur * `SK` - Slovensko * `SI` - Slovinsko * `SO` - Somálsko * `ES` - Španělsko * `AE` - Spojené arabské emiráty * `GB` - Spojené království * `US` - Spojené státy americké * `RS` - Srbsko * `LK` - Srí Lanka * `CF` - Středoafrická republika * `SD` - Súdán * `SR` - Surinam * `SJ` - Svalbard a Jan Mayen * `SH` - Svatá Helena, Ascension a Tristan da Cunha * `LC` - Svatá Lucie * `BL` - Svatý Bartoloměj * `KN` - Svatý Kryštof a Nevis * `MF` - Svatý Martin (francouzská část) * `SX` - Svatý Martin (nizozemská část) * `ST` - Svatý Tomáš a Princův ostrov * `VC` - Svatý Vincenc a Grenadiny * `SE` - Švédsko * `CH` - Švýcarsko * `SY` - Sýrie * `TJ` - Tádžikistán * `TW` - Taiwan * `TZ` - Tanzánie * `TH` - Thajsko * `TG` - Togo * `TK` - Tokelau * `TO` - Tonga * `TT` - Trinidad a Tobago * `TN` - Tunisko * `TR` - Turecko * `TM` - Turkmenistán * `TV` - Tuvalu * `UG` - Uganda * `UA` - Ukrajina * `UY` - Uruguay * `UZ` - Uzbekistán * `CX` - Vánoční ostrov * `VU` - Vanuatu * `VA` - Vatikán * `VE` - Venezuela * `VN` - Vietnam * `TL` - Východní Timor * `WF` - Wallis a Futuna * `ZM` - Zambie * `EH` - Západní Sahara * `ZW` - Zimbabwe
 */
export type AddressCountryEnum = 'AF' | 'AX' | 'AL' | 'DZ' | 'AS' | 'VI' | 'AD' | 'AO' | 'AI' | 'AQ' | 'AG' | 'AR' | 'AM' | 'AW' | 'AU' | 'AZ' | 'BS' | 'BH' | 'BD' | 'BB' | 'BE' | 'BZ' | 'BY' | 'BJ' | 'BM' | 'BT' | 'BO' | 'BQ' | 'BA' | 'BW' | 'BV' | 'BR' | 'VG' | 'IO' | 'BN' | 'BG' | 'BF' | 'BI' | 'TD' | 'ME' | 'CZ' | 'CL' | 'HR' | 'CN' | 'CK' | 'CW' | 'DK' | 'DM' | 'DO' | 'DJ' | 'EG' | 'EC' | 'ER' | 'EE' | 'SZ' | 'ET' | 'FO' | 'FK' | 'FJ' | 'PH' | 'FI' | 'FR' | 'GF' | 'PF' | 'TF' | 'GA' | 'GM' | 'GH' | 'GI' | 'GD' | 'GL' | 'GE' | 'GP' | 'GU' | 'GT' | 'GG' | 'GN' | 'GW' | 'GY' | 'HT' | 'HM' | 'HN' | 'HK' | 'IN' | 'ID' | 'IQ' | 'IR' | 'IE' | 'IS' | 'IT' | 'IL' | 'JM' | 'JP' | 'YE' | 'JE' | 'ZA' | 'GS' | 'KR' | 'SS' | 'JO' | 'KY' | 'KH' | 'CM' | 'CA' | 'CV' | 'QA' | 'KZ' | 'KE' | 'KI' | 'CC' | 'CO' | 'KM' | 'CG' | 'CD' | 'CR' | 'CU' | 'KW' | 'CY' | 'KG' | 'LA' | 'LS' | 'LB' | 'LR' | 'LY' | 'LI' | 'LT' | 'LV' | 'LU' | 'MO' | 'MG' | 'HU' | 'MY' | 'MW' | 'MV' | 'ML' | 'MT' | 'MA' | 'MH' | 'MQ' | 'MU' | 'MR' | 'YT' | 'UM' | 'MX' | 'FM' | 'MD' | 'MC' | 'MN' | 'MS' | 'MZ' | 'MM' | 'NA' | 'NR' | 'DE' | 'NP' | 'NE' | 'NG' | 'NI' | 'NU' | 'NL' | 'NO' | 'NC' | 'NZ' | 'OM' | 'IM' | 'NF' | 'MP' | 'TC' | 'PK' | 'PW' | 'PS' | 'PA' | 'PG' | 'PY' | 'PE' | 'PN' | 'CI' | 'PL' | 'PR' | 'PT' | 'AT' | 'GR' | 'RE' | 'GQ' | 'RO' | 'RU' | 'RW' | 'PM' | 'SB' | 'SV' | 'WS' | 'SM' | 'SA' | 'SN' | 'KP' | 'MK' | 'SC' | 'SL' | 'SG' | 'SK' | 'SI' | 'SO' | 'ES' | 'AE' | 'GB' | 'US' | 'RS' | 'LK' | 'CF' | 'SD' | 'SR' | 'SJ' | 'SH' | 'LC' | 'BL' | 'KN' | 'MF' | 'SX' | 'ST' | 'VC' | 'SE' | 'CH' | 'SY' | 'TJ' | 'TW' | 'TZ' | 'TH' | 'TG' | 'TK' | 'TO' | 'TT' | 'TN' | 'TR' | 'TM' | 'TV' | 'UG' | 'UA' | 'UY' | 'UZ' | 'CX' | 'VU' | 'VA' | 'VE' | 'VN' | 'TL' | 'WF' | 'ZM' | 'EH' | 'ZW';

export const AddressCountryEnum = {
    AF: 'AF' as AddressCountryEnum,
    AX: 'AX' as AddressCountryEnum,
    AL: 'AL' as AddressCountryEnum,
    DZ: 'DZ' as AddressCountryEnum,
    AS: 'AS' as AddressCountryEnum,
    VI: 'VI' as AddressCountryEnum,
    AD: 'AD' as AddressCountryEnum,
    AO: 'AO' as AddressCountryEnum,
    AI: 'AI' as AddressCountryEnum,
    AQ: 'AQ' as AddressCountryEnum,
    AG: 'AG' as AddressCountryEnum,
    AR: 'AR' as AddressCountryEnum,
    AM: 'AM' as AddressCountryEnum,
    AW: 'AW' as AddressCountryEnum,
    AU: 'AU' as AddressCountryEnum,
    AZ: 'AZ' as AddressCountryEnum,
    BS: 'BS' as AddressCountryEnum,
    BH: 'BH' as AddressCountryEnum,
    BD: 'BD' as AddressCountryEnum,
    BB: 'BB' as AddressCountryEnum,
    BE: 'BE' as AddressCountryEnum,
    BZ: 'BZ' as AddressCountryEnum,
    BY: 'BY' as AddressCountryEnum,
    BJ: 'BJ' as AddressCountryEnum,
    BM: 'BM' as AddressCountryEnum,
    BT: 'BT' as AddressCountryEnum,
    BO: 'BO' as AddressCountryEnum,
    BQ: 'BQ' as AddressCountryEnum,
    BA: 'BA' as AddressCountryEnum,
    BW: 'BW' as AddressCountryEnum,
    BV: 'BV' as AddressCountryEnum,
    BR: 'BR' as AddressCountryEnum,
    VG: 'VG' as AddressCountryEnum,
    IO: 'IO' as AddressCountryEnum,
    BN: 'BN' as AddressCountryEnum,
    BG: 'BG' as AddressCountryEnum,
    BF: 'BF' as AddressCountryEnum,
    BI: 'BI' as AddressCountryEnum,
    TD: 'TD' as AddressCountryEnum,
    ME: 'ME' as AddressCountryEnum,
    CZ: 'CZ' as AddressCountryEnum,
    CL: 'CL' as AddressCountryEnum,
    HR: 'HR' as AddressCountryEnum,
    CN: 'CN' as AddressCountryEnum,
    CK: 'CK' as AddressCountryEnum,
    CW: 'CW' as AddressCountryEnum,
    DK: 'DK' as AddressCountryEnum,
    DM: 'DM' as AddressCountryEnum,
    DO: 'DO' as AddressCountryEnum,
    DJ: 'DJ' as AddressCountryEnum,
    EG: 'EG' as AddressCountryEnum,
    EC: 'EC' as AddressCountryEnum,
    ER: 'ER' as AddressCountryEnum,
    EE: 'EE' as AddressCountryEnum,
    SZ: 'SZ' as AddressCountryEnum,
    ET: 'ET' as AddressCountryEnum,
    FO: 'FO' as AddressCountryEnum,
    FK: 'FK' as AddressCountryEnum,
    FJ: 'FJ' as AddressCountryEnum,
    PH: 'PH' as AddressCountryEnum,
    FI: 'FI' as AddressCountryEnum,
    FR: 'FR' as AddressCountryEnum,
    GF: 'GF' as AddressCountryEnum,
    PF: 'PF' as AddressCountryEnum,
    TF: 'TF' as AddressCountryEnum,
    GA: 'GA' as AddressCountryEnum,
    GM: 'GM' as AddressCountryEnum,
    GH: 'GH' as AddressCountryEnum,
    GI: 'GI' as AddressCountryEnum,
    GD: 'GD' as AddressCountryEnum,
    GL: 'GL' as AddressCountryEnum,
    GE: 'GE' as AddressCountryEnum,
    GP: 'GP' as AddressCountryEnum,
    GU: 'GU' as AddressCountryEnum,
    GT: 'GT' as AddressCountryEnum,
    GG: 'GG' as AddressCountryEnum,
    GN: 'GN' as AddressCountryEnum,
    GW: 'GW' as AddressCountryEnum,
    GY: 'GY' as AddressCountryEnum,
    HT: 'HT' as AddressCountryEnum,
    HM: 'HM' as AddressCountryEnum,
    HN: 'HN' as AddressCountryEnum,
    HK: 'HK' as AddressCountryEnum,
    IN: 'IN' as AddressCountryEnum,
    ID: 'ID' as AddressCountryEnum,
    IQ: 'IQ' as AddressCountryEnum,
    IR: 'IR' as AddressCountryEnum,
    IE: 'IE' as AddressCountryEnum,
    IS: 'IS' as AddressCountryEnum,
    IT: 'IT' as AddressCountryEnum,
    IL: 'IL' as AddressCountryEnum,
    JM: 'JM' as AddressCountryEnum,
    JP: 'JP' as AddressCountryEnum,
    YE: 'YE' as AddressCountryEnum,
    JE: 'JE' as AddressCountryEnum,
    ZA: 'ZA' as AddressCountryEnum,
    GS: 'GS' as AddressCountryEnum,
    KR: 'KR' as AddressCountryEnum,
    SS: 'SS' as AddressCountryEnum,
    JO: 'JO' as AddressCountryEnum,
    KY: 'KY' as AddressCountryEnum,
    KH: 'KH' as AddressCountryEnum,
    CM: 'CM' as AddressCountryEnum,
    CA: 'CA' as AddressCountryEnum,
    CV: 'CV' as AddressCountryEnum,
    QA: 'QA' as AddressCountryEnum,
    KZ: 'KZ' as AddressCountryEnum,
    KE: 'KE' as AddressCountryEnum,
    KI: 'KI' as AddressCountryEnum,
    CC: 'CC' as AddressCountryEnum,
    CO: 'CO' as AddressCountryEnum,
    KM: 'KM' as AddressCountryEnum,
    CG: 'CG' as AddressCountryEnum,
    CD: 'CD' as AddressCountryEnum,
    CR: 'CR' as AddressCountryEnum,
    CU: 'CU' as AddressCountryEnum,
    KW: 'KW' as AddressCountryEnum,
    CY: 'CY' as AddressCountryEnum,
    KG: 'KG' as AddressCountryEnum,
    LA: 'LA' as AddressCountryEnum,
    LS: 'LS' as AddressCountryEnum,
    LB: 'LB' as AddressCountryEnum,
    LR: 'LR' as AddressCountryEnum,
    LY: 'LY' as AddressCountryEnum,
    LI: 'LI' as AddressCountryEnum,
    LT: 'LT' as AddressCountryEnum,
    LV: 'LV' as AddressCountryEnum,
    LU: 'LU' as AddressCountryEnum,
    MO: 'MO' as AddressCountryEnum,
    MG: 'MG' as AddressCountryEnum,
    HU: 'HU' as AddressCountryEnum,
    MY: 'MY' as AddressCountryEnum,
    MW: 'MW' as AddressCountryEnum,
    MV: 'MV' as AddressCountryEnum,
    ML: 'ML' as AddressCountryEnum,
    MT: 'MT' as AddressCountryEnum,
    MA: 'MA' as AddressCountryEnum,
    MH: 'MH' as AddressCountryEnum,
    MQ: 'MQ' as AddressCountryEnum,
    MU: 'MU' as AddressCountryEnum,
    MR: 'MR' as AddressCountryEnum,
    YT: 'YT' as AddressCountryEnum,
    UM: 'UM' as AddressCountryEnum,
    MX: 'MX' as AddressCountryEnum,
    FM: 'FM' as AddressCountryEnum,
    MD: 'MD' as AddressCountryEnum,
    MC: 'MC' as AddressCountryEnum,
    MN: 'MN' as AddressCountryEnum,
    MS: 'MS' as AddressCountryEnum,
    MZ: 'MZ' as AddressCountryEnum,
    MM: 'MM' as AddressCountryEnum,
    NA: 'NA' as AddressCountryEnum,
    NR: 'NR' as AddressCountryEnum,
    DE: 'DE' as AddressCountryEnum,
    NP: 'NP' as AddressCountryEnum,
    NE: 'NE' as AddressCountryEnum,
    NG: 'NG' as AddressCountryEnum,
    NI: 'NI' as AddressCountryEnum,
    NU: 'NU' as AddressCountryEnum,
    NL: 'NL' as AddressCountryEnum,
    NO: 'NO' as AddressCountryEnum,
    NC: 'NC' as AddressCountryEnum,
    NZ: 'NZ' as AddressCountryEnum,
    OM: 'OM' as AddressCountryEnum,
    IM: 'IM' as AddressCountryEnum,
    NF: 'NF' as AddressCountryEnum,
    MP: 'MP' as AddressCountryEnum,
    TC: 'TC' as AddressCountryEnum,
    PK: 'PK' as AddressCountryEnum,
    PW: 'PW' as AddressCountryEnum,
    PS: 'PS' as AddressCountryEnum,
    PA: 'PA' as AddressCountryEnum,
    PG: 'PG' as AddressCountryEnum,
    PY: 'PY' as AddressCountryEnum,
    PE: 'PE' as AddressCountryEnum,
    PN: 'PN' as AddressCountryEnum,
    CI: 'CI' as AddressCountryEnum,
    PL: 'PL' as AddressCountryEnum,
    PR: 'PR' as AddressCountryEnum,
    PT: 'PT' as AddressCountryEnum,
    AT: 'AT' as AddressCountryEnum,
    GR: 'GR' as AddressCountryEnum,
    RE: 'RE' as AddressCountryEnum,
    GQ: 'GQ' as AddressCountryEnum,
    RO: 'RO' as AddressCountryEnum,
    RU: 'RU' as AddressCountryEnum,
    RW: 'RW' as AddressCountryEnum,
    PM: 'PM' as AddressCountryEnum,
    SB: 'SB' as AddressCountryEnum,
    SV: 'SV' as AddressCountryEnum,
    WS: 'WS' as AddressCountryEnum,
    SM: 'SM' as AddressCountryEnum,
    SA: 'SA' as AddressCountryEnum,
    SN: 'SN' as AddressCountryEnum,
    KP: 'KP' as AddressCountryEnum,
    MK: 'MK' as AddressCountryEnum,
    SC: 'SC' as AddressCountryEnum,
    SL: 'SL' as AddressCountryEnum,
    SG: 'SG' as AddressCountryEnum,
    SK: 'SK' as AddressCountryEnum,
    SI: 'SI' as AddressCountryEnum,
    SO: 'SO' as AddressCountryEnum,
    ES: 'ES' as AddressCountryEnum,
    AE: 'AE' as AddressCountryEnum,
    GB: 'GB' as AddressCountryEnum,
    US: 'US' as AddressCountryEnum,
    RS: 'RS' as AddressCountryEnum,
    LK: 'LK' as AddressCountryEnum,
    CF: 'CF' as AddressCountryEnum,
    SD: 'SD' as AddressCountryEnum,
    SR: 'SR' as AddressCountryEnum,
    SJ: 'SJ' as AddressCountryEnum,
    SH: 'SH' as AddressCountryEnum,
    LC: 'LC' as AddressCountryEnum,
    BL: 'BL' as AddressCountryEnum,
    KN: 'KN' as AddressCountryEnum,
    MF: 'MF' as AddressCountryEnum,
    SX: 'SX' as AddressCountryEnum,
    ST: 'ST' as AddressCountryEnum,
    VC: 'VC' as AddressCountryEnum,
    SE: 'SE' as AddressCountryEnum,
    CH: 'CH' as AddressCountryEnum,
    SY: 'SY' as AddressCountryEnum,
    TJ: 'TJ' as AddressCountryEnum,
    TW: 'TW' as AddressCountryEnum,
    TZ: 'TZ' as AddressCountryEnum,
    TH: 'TH' as AddressCountryEnum,
    TG: 'TG' as AddressCountryEnum,
    TK: 'TK' as AddressCountryEnum,
    TO: 'TO' as AddressCountryEnum,
    TT: 'TT' as AddressCountryEnum,
    TN: 'TN' as AddressCountryEnum,
    TR: 'TR' as AddressCountryEnum,
    TM: 'TM' as AddressCountryEnum,
    TV: 'TV' as AddressCountryEnum,
    UG: 'UG' as AddressCountryEnum,
    UA: 'UA' as AddressCountryEnum,
    UY: 'UY' as AddressCountryEnum,
    UZ: 'UZ' as AddressCountryEnum,
    CX: 'CX' as AddressCountryEnum,
    VU: 'VU' as AddressCountryEnum,
    VA: 'VA' as AddressCountryEnum,
    VE: 'VE' as AddressCountryEnum,
    VN: 'VN' as AddressCountryEnum,
    TL: 'TL' as AddressCountryEnum,
    WF: 'WF' as AddressCountryEnum,
    ZM: 'ZM' as AddressCountryEnum,
    EH: 'EH' as AddressCountryEnum,
    ZW: 'ZW' as AddressCountryEnum
};